module.exports = __webpack_public_path__ + "img/sun-eclipse.72f1cae5.svg";